/**
 * Formatting utilities for capacity data display
 */

/**
 * Format minutes as hours and minutes (e.g., "2h 30m" or "45m")
 */
export function formatMinutes(minutes: number): string {
  if (minutes === 0) return '0m';

  const hours = Math.floor(minutes / 60);
  const mins = Math.round(minutes % 60);

  if (hours === 0) {
    return `${mins}m`;
  }

  if (mins === 0) {
    return `${hours}h`;
  }

  return `${hours}h ${mins}m`;
}

/**
 * Format utilization as percentage
 */
export function formatUtilization(utilization: number): string {
  return `${Math.round(utilization)}%`;
}

/**
 * Format date as readable string (e.g., "Mon, Mar 1")
 */
export function formatDateReadable(dateStr: string): string {
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  });
}

/**
 * Format provider name (capitalize first letter of each word)
 */
export function formatProviderName(name: string): string {
  return name
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}
